/**
 * Resolves once the browser has painted what was just rendered.
 *
 * A long synchronous job started right after a `setState` runs before the
 * frame that state change asked for, so the cook never sees it: « Planifier
 * les 7 jours suivants » set its spinner, then generated for 2-3 s in the same
 * task, and the spinner never appeared (#851). A `requestAnimationFrame`
 * callback runs just before the paint; the timeout queued from it runs just
 * after.
 *
 * A hidden tab never fires `requestAnimationFrame`, so a deadline stops the job
 * from waiting for the tab to come back.
 */
export function afterPaint(deadlineMs = 100): Promise<void> {
  return new Promise((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };
    setTimeout(finish, deadlineMs);
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(() => setTimeout(finish, 0));
    }
  });
}
